import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g fill=\"currentColor\" fill-rule=\"evenodd\"><rect opacity=\".47\" x=\"3\" y=\"6\" width=\"18\" height=\"3\" rx=\"1.5\"></rect><rect x=\"14\" y=\"4\" width=\"4\" height=\"7\" rx=\"2\"></rect><rect opacity=\".47\" x=\"3\" y=\"15\" width=\"18\" height=\"3\" rx=\"1.5\"></rect><rect x=\"6\" y=\"13\" width=\"4\" height=\"7\" rx=\"2\"></rect></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }